// Ukrainian plural for "товар": 1 товар, 2 товари, 5 товарів
export function itemsWord(n) {
  const last = n % 10;
  const lastTwo = n % 100;
  if (last === 1 && lastTwo !== 11) return 'товар';
  if (last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) return 'товари';
  return 'товарів';
}
